import { SelectOption } from '@/components/Form/src/types'
import { ExamAdminEnum } from './ExamAdminEnum'

const ExaminationType: SelectOption[] = [
  {
    value: ExamAdminEnum.ExaminationType['Part I'],
    label: 'Part I'
  },
  {
    value: ExamAdminEnum.ExaminationType['Part II'],
    label: 'Part II'
  },
  {
    value: ExamAdminEnum.ExaminationType['Part III'],
    label: 'Part III'
  }
]

export const ExaminationOption = { ExaminationType }
